export enum RegionsEnum {
  US = 1,
  EMEIA = 2,
  APAC = 3,
}
export enum TemplateEnum {
  Americas = 1,
  ROW = 2,
  TotalCost = 3
}
